import {
  createMutationKeys,
  createQueryKeys,
  mergeQueryKeys,
} from '@lukemorales/query-key-factory'
import { APIAxiosInstance } from '@core/utils/api-axios-instance'
import { RequestTypes } from './requestTypes'
import { createQueryKeyString } from '@core/react-query/queryParams'
import { PageResponse } from '@core/entities/pagination'
import { ITaskDraft } from '@core/entities/task/TaskDraft'
import { ITaskPaginated } from '@core/entities/task/TaskPaginated'

const tasksQueryKeys = createQueryKeys('tasks', {
  allTasks: ({
    organisationId,
    filters,
    dateRange,
    page,
    size,
  }: RequestTypes['getAllTasks']) => {
    return {
      queryKey: [
        organisationId,
        JSON.stringify(filters),
        { ...dateRange },
        page,
        size,
      ],
      queryFn: async ({ pageParam = 1 }) => {
        const queryParams = createQueryKeyString({
          organisationId,
          filters: JSON.stringify(filters),
          ...dateRange,
          page: page ? page : pageParam,
          size,
        })
        const { data } = await APIAxiosInstance.get(`tasks${queryParams}`)

        return data as PageResponse<ITaskPaginated>
      },
    }
  },
  myTasks: ({
    organisationId,
    filters,
    dateRange,
    page,
    size,
  }: RequestTypes['getMyTasks']) => {
    return {
      queryKey: [
        organisationId,
        JSON.stringify(filters),
        { ...dateRange },
        page,
        size,
      ],
      queryFn: async ({ pageParam = 1 }) => {
        const queryParams = createQueryKeyString({
          organisationId,
          filters: JSON.stringify({
            data: [...(filters?.data || []), { operator: 'FILTER_MY_TASKS' }],
          }),
          ...dateRange,
          page: page ? page : pageParam,
          size,
        })
        const { data } = await APIAxiosInstance.get(`tasks${queryParams}`)

        return data as PageResponse<ITaskPaginated>
      },
    }
  },
  draftTasks: ({
    organisationId,
    projectIds,
    page,
    size,
  }: RequestTypes['getDrafts']) => {
    return {
      queryKey: [organisationId, projectIds, page, size],
      queryFn: async ({ pageParam = 1 }) => {
        const queryParams = createQueryKeyString({
          organisationId,
          projectIds,
          page: page ? page : pageParam,
          size,
        })

        const { data } = await APIAxiosInstance.get(
          `tasks/drafts${queryParams}`,
        )

        return data as PageResponse<ITaskDraft>
      },
    }
  },
})

const tasksMutationKeys = createMutationKeys('tasks', {})

const tasksKeys = mergeQueryKeys(tasksQueryKeys, tasksMutationKeys).tasks

export { tasksKeys }
